import { z } from 'zod'

export const mapZodToFormikErrors = <T>(zodError: z.ZodError<T>) => {
  const result: Record<string, any> = {}

  for (const error of zodError.errors) {
    const path = error.path.filter(Boolean)
    let current = result

    path.forEach((segment, index) => {
      if (index === path.length - 1) {
        current[segment] = error.message
      } else {
        if (!current[segment]) {
          current[segment] = {}
        }
        current = current[segment]
      }
    })
  }

  return result
}
